export const HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
export const PRODUCT_HOME_BREAKPOINT = 1280;
export const CREATE_BREAKPOINT = 1130;
